exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#buscador_resultados .modal-body {\n  background: #a7a7a7;\n}", ""]);

// exports
